module.exports = __webpack_public_path__ + "static/media/teachers-07.dc3d4927.png";